export const DEFAULT_CONNECTION_STYLE_ID = 'flow';

export const CONNECTION_STYLE_LIST = Object.freeze([
  Object.freeze({
    id: 'flow',
    name: 'Flow',
    description: 'Smooth, organic curves.',
  }),
  Object.freeze({
    id: 'branch',
    name: 'Branch',
    description: 'Shared trunks with horizontal and vertical branches.',
  }),
  Object.freeze({
    id: 'rounded',
    name: 'Rounded',
    description: 'Individual right-angle routes with softened corners.',
  }),
]);

const CONNECTION_STYLE_IDS = new Set(CONNECTION_STYLE_LIST.map(({ id }) => id));

export function normalizeConnectionStyleId(value) {
  return CONNECTION_STYLE_IDS.has(value) ? value : DEFAULT_CONNECTION_STYLE_ID;
}
